import { DateTime } from 'luxon';

export const ONE_SECOND = 1000;
// ONE SECOND, in milliseconds. Adjustable because otherwise it's painful to test
export const TIMEOUT_MULTIPLIER = ONE_SECOND;
// Convert token.exp to Date/Time
export const TOKEN_EXP_DATETIME = 1000;
// At 13 minutes, we start showing the warning.
export const WARNING_TIMEOUT = 13 * 60 * TIMEOUT_MULTIPLIER;
// At 15 minutes they will be timed out
export const TIMEOUT_LIMIT = 15 * 60 * TIMEOUT_MULTIPLIER;

export const PERSISTANCE_CONSTANT_LOCAL_STORAGE = 'activityMonitoring:lastActivityTime';
export const getLatestActivityTime = () => {
  const rawDate = localStorage.getItem(PERSISTANCE_CONSTANT_LOCAL_STORAGE);

  return DateTime.fromJSDate(rawDate ? new Date(rawDate) : new Date('1970-01-01T00:00:00.000Z'));
};

export const setLatestActivityTime = (lastActivityTime: Date = new Date()) =>
  localStorage.setItem(PERSISTANCE_CONSTANT_LOCAL_STORAGE, lastActivityTime.toISOString());

export const jwtCookieName = 'spruce_jwt';
export const spruceClaimsFieldName = 'https://spruce.co/jwt/v2';
